


































import Vue from "vue";
export default Vue.extend({
  props: {
    targetId: {
      type: String,
      default: "app",
    },
    modalWidth: {
      type: String,
      default: "400px",
    },
  },
  data() {
    return {
      sizeInterval: setTimeout(() => true, 0) as number,
      left: 0 as number,
      top: 0 as number,
      height: 100 as number,
      width: 100 as number,
    };
  },
  methods: {
    modalSyncSize() {
      const el = document.getElementById(this.targetId);
      if (el != null) {
        this.left = el.offsetLeft;
        this.top = el.offsetTop;
        this.height = el.offsetHeight;
        this.width = el.offsetWidth;
      }
    },
  },
  mounted() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    /**
     * NOTE : overflow-modal-scroll.
     * Berikan class overflow-modal-scroll pada overflow element
     * supaya autoscoll keatas ketika modal terbuka
     */
    let elScroll = document.getElementsByClassName("overflow-modal-scroll");
    for (let el of elScroll) {
      el.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }

    this.modalSyncSize();
    this.sizeInterval = setInterval(() => {
      this.modalSyncSize();
    }, 300);
  },
  beforeDestroy() {
    clearInterval(this.sizeInterval);
  },
});
